import { Swiper } from 'swiper'
import { Navigation } from 'swiper/modules'

function init($blocks) {

  if(!$blocks) return;

  $blocks.forEach($block => {

    const $slider = $block.querySelector('.swiper')

    let $nextElement = $block.querySelector('.swiper-mobile-nav .swiper-slide-next');
    let $prevElement = $block.querySelector('.swiper-mobile-nav .swiper-slide-prev');

    if(window.innerWidth > 976) {
      $nextElement = $block.querySelector('.swiper-desktop-nav .swiper-slide-next');
      $prevElement = $block.querySelector('.swiper-desktop-nav .swiper-slide-prev');
    }


    let swiper = new Swiper($slider, {
      modules: [Navigation],
      slidesPerView: 1,
      loop: true,
      spaceBetween: 12,
      navigation: {
        nextEl: $nextElement,
        prevEl: $prevElement,
      },
      breakpoints: {
        320: {
          slidesPerView: 1,
          spaceBetween: 12
        },
        620: {
          slidesPerView: 2
        },
        972: {
          slidesPerView: 3
        },
      },
      on: {
        afterInit: function () {


        }
      }
    })
  })


}

const $blocks = document.querySelectorAll('.block-slider')

init($blocks)
